<template>
    <div class="sidebar">
       
        <el-menu class="sidebar-el-menu" :default-active="onRoutes" :collapse="collapse" background-color="#324157"
            text-color="#bfcbd9" active-text-color="#20a0ff" unique-opened router>
            <template v-for="item in this.$store.state.item">
                <template v-if="item.subs">
                    <el-submenu :index="item.index" :key="item.index">
                        <template slot="title">
                            <i :class="item.icon"></i>
                            <span slot="title">{{ item.title }}</span>
                        </template>
                        <template v-for="subItem in item.subs">
                            <el-submenu v-if="subItem.subs" :index="subItem.index" :key="subItem.index">
                                <template slot="title">{{ subItem.title }}</template>
                                <el-menu-item v-for="(threeItem,i) in subItem.subs" :key="i" :index="threeItem.index">
                                    {{ threeItem.title }}</el-menu-item>
                            </el-submenu>
                            <el-menu-item v-else :index="subItem.index" :key="subItem.index">{{ subItem.title }}
                            </el-menu-item>
                        </template>
                    </el-submenu>
                </template>
                <template v-else>
                    <el-menu-item :index="item.index" :key="item.index">
                        <i :class="item.icon"></i>
                        <span slot="title">{{ item.title }}</span>
                    </el-menu-item>
                </template>
            </template>
          
        </el-menu>
    </div>
</template>

<script>
    import bus from '../common/bus';
    export default {
        data() {
            return {
                collapse: false,
                subList: [],
                items: [{
                        icon: 'el-icon-lx-home',
                        index: 'dashboard',
                        title: '数据统计'
                    },
                    {
                        icon: 'el-icon-lx-cascades',
                        index: 'merchants-Manage',
                        title: '商户管理',
                       
                    },
                    {
                        icon: 'el-icon-lx-copy',
                        index: 'order',
                        title: '交易明细'
                    },
                    {
                        icon: 'el-icon-lx-home',
                        index: 'add-Merchant',
                        title: '系统设置'
                    },
                    {
                        icon:'el-icon-s-custom',
                        index:'main-service-provider',
                        title:'主服务商'
                    },
                    {
                        icon:'el-icon-user',
                        index:'sub-service-provider',
                        title:'子服务商'
                    }
                ],
                item1: [{
                        icon: 'el-icon-lx-home',
                        index: 'dashboard',
                        title: '数据统计'
                    },
                    {
                        icon: 'el-icon-lx-home',
                        index: 'add-Merchant',
                        title: '商户设置'
                    },
                    {
                        icon: 'el-icon-lx-copy',
                        index: 'order',
                        title: '交易明细'
                    },
                    {
                        icon:'el-icon-bell',
                        index: 'voice',
                        title:'语音播报'
                    }
                ]
            };
        },
        mounted(){
        }
        ,
        computed: {
            onRoutes() {
                return this.$route.path.replace('/', '');
            },
            fullName() {
                if (sessionStorage.getItem('merchants_id')) {
                    return this.item1
                } else {
                    return this.items
                }
            }

        },
        created() {

            if(sessionStorage.getItem("merchants_id")){
                this.$store.commit('setItem', this.item1)
            }
            else{
                this.$store.commit('setItem', this.items)
            }
            // 通过 Event Bus 进行组件间通信，来折叠侧边栏
            // bus.$on('collapse', msg => {
            //     this.collapse = msg;
            //     bus.$emit('collapse-content', msg);
            // });
        }
    };
</script>

<style scoped>
    .sidebar {
        display: block;
        position: absolute;
        left: 0;
        top: 70px;
        bottom: 0;
        overflow-y: scroll;
    }

    .sidebar::-webkit-scrollbar {
        width: 0;
    }

    .sidebar-el-menu:not(.el-menu--collapse) {
        width: 250px;
    }

    .sidebar>ul {
        height: 100%;
    }
</style>